module.exports = __webpack_public_path__ + "static/omnicode-services-b54ad12728da4d4e39a77449e194dd41.svg";